export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/6084b339fc3a78c83811e4e1149e506c/3564ec11419a91dc68d58bb73639f075.jpeg" 
                alt="ICM Logo" 
                className="h-12 w-12 object-contain bg-white rounded-lg p-1"
              />
              <div>
                <h3 className="text-lg font-bold">ICM</h3>
                <p className="text-sm text-blue-200">Instituto de Clínica Médica</p>
              </div>
            </div>
            <p className="text-sm text-blue-200 leading-relaxed">
              Atención médica integral con profesionales especializados en Mar del Plata.
            </p>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Contacto</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-blue-300 mt-1"></i>
                <p className="text-sm text-blue-200">
                  Rawson 1006, Mar del Plata<br />
                  Provincia de Buenos Aires, Argentina
                </p>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-blue-300"></i>
                <a href="tel:+542234515475" className="text-sm text-blue-200 hover:text-white cursor-pointer">
                  0223 451-5475
                </a>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-blue-300"></i>
                <a href="https://wa.me/5492235470285" target="_blank" rel="noopener noreferrer" className="text-sm text-blue-200 hover:text-white cursor-pointer">
                  223-547-0285
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">Horario de Verano</h4>
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-blue-200">Lunes - Viernes:</span>
                <span className="text-white font-medium">9:00 - 15:00</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-blue-200">Sábados - Domingos:</span>
                <span className="text-white font-medium">Cerrado</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8">
          <div className="bg-blue-800 rounded-lg p-4 mb-6">
            <p className="text-xs text-blue-200 text-center leading-relaxed">
              <i className="ri-information-line mr-1"></i>
              <strong>Aviso Importante:</strong> La información de este sitio web no reemplaza la consulta médica presencial. 
              Ante cualquier duda o síntoma, consulte con un profesional de la salud.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-blue-200">
            <p>© 2025 ICM - Instituto de Clínica Médica. Todos los derechos reservados.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}